export default __webpack_public_path__ + "static/media/session-expired-image.98094e40.png";